import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateCompanyDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/CreateUpdateCompanyDto';

interface CompanyEditorTabInvoicingProps {
  company: CreateUpdateCompanyDto;
  propertyChange: (obj: Partial<CreateUpdateCompanyDto>) => void;
  readOnly: boolean;
}

export const CompanyEditorTabInvoicing: React.FC<
  CompanyEditorTabInvoicingProps
> = ({ company, propertyChange, readOnly }) => {
  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="monthlySettlement" label="Rozliczana miesięcznie">
        <Form.Check
          type="checkbox"
          checked={company?.monthlySettlement ? true : false}
          onChange={e =>
            propertyChange({ monthlySettlement: e.target.checked })
          }
          disabled={readOnly}
        />
      </FormRow>
      <FormRow controlId="invoicesSettlement" label="Rozliczana wg faktur">
        <Form.Check
          type="checkbox"
          checked={company?.invoicesSettlement ? true : false}
          onChange={e =>
            propertyChange({ invoicesSettlement: e.target.checked })
          }
          disabled={readOnly}
        />
      </FormRow>
      {company?.monthlySettlement && (
        <>
          <FormRow
            controlId="autoInvoice"
            label="Automatyczne wystawianie faktur"
          >
            <Form.Check
              type="checkbox"
              checked={company?.autoInvoice ? true : false}
              onChange={e => propertyChange({ autoInvoice: e.target.checked })}
              disabled={readOnly}
            />
          </FormRow>
          <FormRow
            controlId="autoApproveInvoice"
            label="Automatyczne zatwierdzanie faktur"
          >
            <Form.Check
              type="checkbox"
              checked={company?.autoApproveInvoice ? true : false}
              onChange={e =>
                propertyChange({ autoApproveInvoice: e.target.checked })
              }
              disabled={readOnly || !company?.autoInvoice}
            />
          </FormRow>
          <FormRow controlId="invoicePaymentDays" label="Liczba dni płatności">
            <Form.Control
              type="number"
              min={0}
              max={90}
              step={1}
              value={company?.invoicePaymentDays ?? ''}
              onChange={e =>
                propertyChange({
                  invoicePaymentDays: e.target.value
                    ? Number(e.target.value)
                    : null,
                })
              }
              disabled={readOnly}
            />
          </FormRow>
          <FormRow
            controlId="invoiceIncludeExaminedNames"
            label="Nazwiska badanych w pozycjach faktury"
          >
            <Form.Check
              type="checkbox"
              checked={company?.invoiceIncludeExaminedNames !== false}
              onChange={e =>
                propertyChange({
                  invoiceIncludeExaminedNames: e.target.checked,
                })
              }
              disabled={readOnly}
            />
          </FormRow>
        </>
      )}
    </Form>
  );
};
